module.exports = __webpack_public_path__ + "img/20190622131957143.45866ca6.png";